<template>
  <div class="notes-section" >

    <draggable class='note-spliter' group="notes" :list='notes.notes_with_recursive_children' @change='onNoteMove($event, notes)' dragClass="dragging-ticket" ghostClass="ghost-ticket" chosenClass="chosen-ticket" handle=".handle">

    <div v-for='(note, indexNote) in notes.notes_with_recursive_children' :key='note.id' class="note-li" style="margin-left: 30px;">

      <div class="drag-handle">
        <v-icon class='handle'>fas fa-grip-vertical</v-icon>
      </div>

      <div class="notes-title-arrow-btns" v-if='note.child_notes_recursive'>
        <div v-if='note.child_notes_recursive.length > 0'>
          <v-icon class='arrow-btn' v-show='note.active' @click="note.active = false">fas fa-chevron-down</v-icon>
          <v-icon class='arrow-btn' v-show='!note.active' @click="note.active = true">fas fa-chevron-right</v-icon>
        </div>
      </div>

      <div class="note" @click='openTicket(note)' :class="{'focused': note.focus}">

        <div class="title" v-on:click.stop>
          <input type="text" v-model='note.title' :ref="'bd' + note.id" v-on:keyup.enter="addNote(0, notes, indexNote)" @focus="note.focus = true" @blur="note.focus = false;updateNote(note)" role="button" aria-pressed="false" tabindex="0" placeholder="Write a note name">
        </div>

         <div class="icons">

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }" v-if='note.status'>
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class='icon-dot'>fas fa-ellipsis-h</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>Duplicate</v-list-item-title>
              </v-list-item>
              <v-list-item @click='addSubnote(note, notes, indexNote)'>
                <v-list-item-title>Sub Category</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Delete Note</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </div>

        <div class="status">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }" v-if='note.status'>
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="note.status == 'to-do'" class='icon-progress' color='#f4a261'>fas fa-tasks</v-icon>
                <v-icon v-if="note.status == 'In-Progress'" class='icon-progress' color='#3a6fd2'>far fa-clock</v-icon>
                <v-icon v-if="note.status == 'Completed'" class='icon-progress' color='#4aff01'>far fa-check-circle</v-icon>

                <span v-if="note.status == 'to-do'" class="icon-text">{{note.status}}</span>
                <span v-if="note.status == 'In-Progress'" class="icon-text">{{note.status}}</span>
                <span v-if="note.status == 'Completed'" class="icon-text">{{note.status}}</span>
                <v-icon class='icon-arrow'>fas fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="changeStatus(note, 'to-do')">
                <v-list-item-title>To-Do</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(note, 'In-Progress')">
                <v-list-item-title>In-Progress</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(note, 'Completed')">
                <v-list-item-title>Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        {{note.id}}
      </div>

      <!-- Subnotes -->
      <div v-show='note.active'>
        <subnote :notes="note" :moduleId="moduleId" :key="componentKey"></subnote>
      </div>
      <!-- Subnotes end -->

    </div>

  </draggable>

  </div>
</template>

<script>
import api from '@/api'
import draggable from 'vuedraggable'
import Subnote from '@/components/dashboard/Subnote'

export default {
  name: 'Subnote',
  props: ['notes', 'moduleId'],
  components: {
    draggable,
    Subnote
  },

  data () {
    return {
      componentKey: 0
    }
  },

  computed: {

  },

  methods: {

    // save note
    async updateNote (note) {
      const response = await api.notes.update(note, note.id)
      if (response.status < 300) {
        console.log('Note updated!', response.data)
      } else {
        console.log('Response error', response)
      }
    },

    addSubnote (parentNote, item, index=null) {
      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        parent_id: parentNote.id,
        module_id: this.moduleId,
      }

      this.storeSubNote(note, parentNote, item, index)
    },

    // save note
    async storeSubNote (note, parentNote, item, index=null) {
      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {

        if (!parentNote.child_notes_recursive) {
          parentNote.child_notes_recursive = []
        }

          parentNote.child_notes_recursive.push(response.data.note) // add element

          this.$store.commit('incrementState')

          this.$nextTick(() => {
            let ref = 'bd' + response.data.note.id // find ref of element
            this.focusInput(ref) // focus on next element
          })
      } else {
        console.log('Response sub error', response)
      }
    },

    focusInput(ref) {
      console.log('refs', this.$refs)
      console.log('ref', ref)
      setTimeout(() => this.$refs[ref][0].focus(), this.timeout)
    },

    changeStatus (note, status) {
      // TODO
      note.status = status
      this.updateNote(note, status)
    },

    customRender() {
      this.componentKey += 1;
    },



    orderNotesInsideParentNote () {
      let parentNotes = this.notes.child_notes_recursive
      console.log('parentNotes', parentNotes)
    }

  },

  mounted () {

  }
}
</script>


<style lang="scss" scoped="scoped">

  .dragging-ticket {
    opacity: 0 !important;
  }

  .ghost-ticket {
    width: 100% !important;
    height: 3px !important;
    background: #dadada !important;
    overflow: hidden !important;

    .handle {

    }
  }

  .chosen-ticket {

  }

  .notes-section {

    .note-li {
      width: calc(100% + 45px);
      margin-left: -45px;

      &:hover {

        .drag-handle {
          display: block;
        }
      }

      .drag-handle {
        float: left;
        width: 20px;
        margin-top: 14px;
        margin-left: 1px;
        cursor: pointer;
        transition: all 0.5s;
        display: none;


        &:hover {
          opacity: 0.65;
        }

        .handle {
          font-size: 18px;
          color: #a0aabd;
        }
      }
    }

    .notes-title-arrow-btns {
      position: absolute;
      width: 20px;
      margin-left: 25px;
      line-height: 60px;

      button:before {
        font-size: 14px;
        color: #A0AABD;
      }
    }

    .note {
      width: calc(100% - 45px);
      height: 60px;
      margin-left: 45px;
      margin-top: 15px;
      margin-bottom: 15px;
      line-height: 60px;
      border-left: 5px solid #4c84ff;
      border-radius: 5px;
      background: #fff;
      transition: all 0.25s;
      cursor: pointer;

      &:hover {
        background: #EFF1F6;

        .title {
          background: #fff;
        }
      }

      .checkbox {
        float: left;

        .custom-checkbox {
          padding-left: 20px;
        }
      }


      .title {
        float: left;
        width: 40%;
        height: 40px;
        margin-top: 10px;
        margin-left: 15px;
        padding-left: 15px;
        font-size: 16px !important;
        font-weight: 400;
        border-radius: 5px;
        line-height: 42px;
        color: #3A414F;

        input {
          width: 100%;
          outline: none;
          color: #8790a1;
        }
        input::placeholder {
          color: #dedfe0;
        }
      }

      .needs {
        float: left;
        margin-left: 10%;
        width: 15%;
        padding-left: 5px;
        font-size: 12px !important;
        font-weight: 400;
        line-height: 64px;
        color: #8790a1;
      }

      .status {
        float: right;

        .icon-dot {

        }

        .icon-progress {
          font-size: 16px;
        }

        .icon-text {
          padding-top: 2px;
          padding-left: 5px;
          font-family: 'Roboto', sans-serif;
          font-size: 12px !important;
          font-weight: 400;
          text-transform: capitalize;
          letter-spacing: 0;
          color: #9fa9bc;
        }

        .icon-arrow {
          font-size: 16px;
          padding-left: 5px;
          color: #9fa9bc;
        }
      }

      .icons {
        float: right;
        padding-right: 20px;

        .icon-dot {
          font-size: 14px;
          color: #9fa9bc;
          cursor: pointer;
          transition: all 0.25s;

          &:hover {
            opacity: 0.7;
          }
        }

        .icon-full {
          font-size: 20px;
          color: #9fa9bc;
          cursor: pointer;
          transition: all 0.25s;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    .add-note {
      margin-top: 10px;
      padding-left: 15px;
      font-size: 14px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }

    .add-subnote {
      margin-top: -10px;
      margin-bottom: 10px;
      padding-left: 30px;
      font-size: 12px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }
  }

</style>
